import { Typography } from '@scale/scaleui';
import { ISensorFusionStageDefinitionLookupDto } from '@scale/sensor-fusion-shared';

import { COMPLETE_SUBSTAGES_CORP_TOOL_PATH, QM_PROJECT_LOOKUP_PATH } from '../constants';
import { useSensorFusionLookupContext } from '../contexts/SensorFusionLookupContext';

type StageDefinitionToolsPanelProps = {
  stageDefinition: ISensorFusionStageDefinitionLookupDto;
};

const StageDefinitionToolsPanel = ({ stageDefinition }: StageDefinitionToolsPanelProps) => {
  const { scaleDashboardFrontendUrl } = useSensorFusionLookupContext() ?? {};

  const legacyProjectUrl = `${scaleDashboardFrontendUrl ?? ''}/${QM_PROJECT_LOOKUP_PATH}/${
    stageDefinition.childProject.id
  }`;
  const completeSubstagesUrl = `${
    scaleDashboardFrontendUrl ?? ''
  }/${COMPLETE_SUBSTAGES_CORP_TOOL_PATH}`;

  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <Typography.H3>Tools</Typography.H3>
      <ul className="flex flex-col ml-2 gap-1">
        <li>
          <a className="text-info-700" href={legacyProjectUrl}>
            View Stage as legacy project
          </a>
        </li>
        <li>
          <a className="text-info-700" href={completeSubstagesUrl}>
            Complete Substage Instances
          </a>
        </li>
      </ul>
    </div>
  );
};

export default StageDefinitionToolsPanel;
